import { SvgIconComponent } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab'
import { styled, useTheme } from '@mui/material/styles'
import { FC } from 'react'

interface CustomButtonProps {
  title: string
  Icon: SvgIconComponent
  className?: string
  disabled?: boolean
  isPending?: boolean
  onClick?: () => void
  type?: string
}

const CustomButton: FC<CustomButtonProps> = ({ title, Icon, className, isPending = false, onClick, disabled }) => {
  const theme = useTheme()

  const StyledButton = styled(LoadingButton)({
    backgroundColor: disabled ? '#34AA44' : '#34AA44',
    color: disabled ? theme.palette.action.disabled : 'white',
    padding: '0.6rem',
    borderRadius: '9px',
    gap: '0.4rem',
    minWidth: '30%',
    maxWidth: '30%',
    transition: 'background-color 0.2s',
    whiteSpace: 'normal',
    textAlign: 'center',
    lineHeight: 1,
    fontSize: '11px',
    fontWeight: 400,
    marginTop: '0.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: disabled ? '#A5D6A7' : '#218c54',
    },
    '&.Mui-disabled': {
      backgroundColor: '#A5D6A7', 
      color: theme.palette.action.disabled,
    },
    '& .MuiButton-endIcon': {
      marginTop: '0.3rem',
      marginLeft: '0.rem',
    },
    
    [theme.breakpoints.down('sm')]: {
      marginLeft: '-1rem',
      minWidth: '100%',
      maxWidth: '100%',
    },
  })

  return (
    <StyledButton
      className={`loan-button ${className}`}
      onClick={onClick}
      endIcon={<Icon />}
      variant="contained"
      loading={isPending}
      type="submit"
      disabled={false}
    >
      <span style={{ hyphens: 'auto' }}>{title}</span>
    </StyledButton>
  )
}

export default CustomButton
